var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Outline",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7215642,0.372779414 L15.3435728,16.8285427 C15.3644336,17.3804333 14.9339489,17.8447401 14.3820583,17.8656009 C14.3424704,17.8670973 14.3028287,17.8662399 14.2633426,17.8630332 L7.80179439,17.3382889 C7.25132187,17.2935849 6.76883594,17.7035912 6.7241319,18.2540637 C6.67942786,18.8045362 7.08943422,19.2870222 7.63990674,19.3317262 L14.1014549,19.8564705 C14.2199132,19.8660905 14.3388385,19.8686628 14.457602,19.8641737 C16.1132739,19.8015912 17.404728,18.4086708 17.3421456,16.7529989 L16.720137,0.297235698 C16.6992761,-0.254654935 16.2349693,-0.685139654 15.6830787,-0.664278832 C15.1311881,-0.643418011 14.7007034,-0.179111219 14.7215642,0.372779414 Z",
    id: "shape",
    transform: "translate(12.032562, 9.600654) rotate(-315.000000) translate(-12.032562, -9.600654) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.1f0985e542da5ad934ad871f5d082153.svg";
export { ForwardRef as ReactComponent };